
import { useEffect, useState } from 'react'
import { useWeb3Context } from './useWeb3Context';
import { getAccountTransactionsBasedOnContract } from '../helpers/calls';
import { universeContract } from '../utils/contracts';

function useGalleryTokens(refresh: boolean = false) {
    const { address, provider } = useWeb3Context();
    const [galleryNFTs, setGalleryNFTs]: any = useState([]);
    const [galleryNFTsIsLoading, setGalleryNFTsIsLoading] = useState(true);

    useEffect(() => {
        const getMintedTokensData = async () => {
            if (address) {
                const transactions = await getAccountTransactionsBasedOnContract(address)
                const result = transactions.result
                let arr: Array<any> = []
                let count: number = 0;
                if (transactions && result && result.length > 0) {
                    for (let i = 0; i < result.length; i++) {
                        // Get Bought Token ID's
                        const tokenID = result[i].tokenID;
                        const baseURL = await universeContract(provider).tokenURI(tokenID);
                        const res = await fetch(baseURL, { method: 'GET' })
                        const json = await res.json()
                        if (json) {
                            json.tokenID = tokenID
                            arr.push(json);
                            count++;
                        }
                        if (count >= result.length) {
                            setGalleryNFTs(arr);
                            setGalleryNFTsIsLoading(false);
                        }
                    }
                } else {
                    setGalleryNFTsIsLoading(false);
                }
            }
        }

        getMintedTokensData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address, refresh])

    return {
        galleryNFTs,
        galleryNFTsIsLoading
    }
}

export default useGalleryTokens;